module.exports = __webpack_public_path__ + "images/iphone@2x-6c0b5e.png";